import Info from '@clearkit/icons/glyphs/Info';
import { CKButton } from 'clearkit';
import CopyText from 'react-copy-text';

import styles from './styles';

const Integration = ({
  classes,
  snippet,
  integrationText,
  copyText,
  textAreaHeight,
  copyButtonText = 'Copy code',
}) => {
  const [textToCopy, setSnippet] = useState('');
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    setIsCopied(true);
    setTimeout(() => {
      setSnippet('');
      setIsCopied(false);
    }, 2000);
  };

  return (
    <div>
      <div className={classes.integrationCopy}>{integrationText}</div>

      <div className={classes.snippetContainer}>
        <textarea
          readOnly
          style={{ height: textAreaHeight }}
          value={snippet}
          onClick={(event) => {
            event.target.select();
          }}
          className={classes.snippet}
        />
        <div className={classes.copyContainer}>
          <div className="flex items-center text-sm font-medium gap-2 text-blue">
            <Info />
            <span>{copyText}</span>
          </div>

          <div>
            <CKButton onClick={() => setSnippet(snippet)} variant="simple">
              {isCopied ? 'Copy success!' : copyButtonText}
            </CKButton>
            <CopyText text={textToCopy} onCopied={handleCopy} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(Integration);
